'use client';

import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@kit/ui/utils';

const SIZES = {
  xs: { logoHeight: 20, fontSize: 'text-sm' },
  sm: { logoHeight: 24, fontSize: 'text-base' },
  md: { logoHeight: 36, fontSize: 'text-xl' },
  lg: { logoHeight: 48, fontSize: 'text-2xl' },
} as const;

interface BalleeLogoHeaderProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  href?: string | null;
  showText?: boolean;
  'aria-label'?: string;
}

/**
 * BalleeLogoHeader - Navbar/Header variant
 * Ballee "B" icon + "Ballee" wordmark lockup
 * Uses the existing /balleeLogo.svg asset
 */
export function BalleeLogoHeader({
  className,
  size = 'md',
  href,
  showText = true,
  'aria-label': ariaLabel = 'Ballee',
}: BalleeLogoHeaderProps) {
  const config = SIZES[size];

  const content = (
    <span
      className={cn('inline-flex items-center gap-2', className)}
      role="img"
      aria-label={ariaLabel}
    >
      <Image
        src="/balleeLogo.svg"
        alt=""
        width={config.logoHeight}
        height={config.logoHeight}
        aria-hidden="true"
      />
      {showText && (
        <span
          className={cn(
            'font-heading font-bold tracking-tight',
            config.fontSize,
          )}
        >
          Ballee
        </span>
      )}
    </span>
  );

  if (href != null) {
    return (
      <Link href={href} aria-label={ariaLabel} prefetch={true}>
        {content}
      </Link>
    );
  }

  return content;
}
